import { Component, OnInit, inject } from '@angular/core';

import { DsButton } from '@frontend/ui/button';
import { CashierService, Page } from '@frontend/vanilla/core';
import { TrustAsHtmlPipe } from '@frontend/vanilla/shared/browser';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { ImageComponent } from '@frontend/vanilla/shared/image';
import { RtmsLayerConfig } from '@frontend/vanilla/shared/rtms';

import { BonusResourceService } from '../../bonus-resource.service';
import { RtmsOverlayComponentBase } from './rtms-overlay-component-base';

@Component({
    imports: [TrustAsHtmlPipe, ImageComponent, IconCustomComponent, DsButton],
    selector: 'vn-rtms-bonus-teaser',
    templateUrl: 'rtms-bonus-teaser.component.html',
})
export class RtmsBonusTeaserComponent extends RtmsOverlayComponentBase implements OnInit {
    private bonusResourceService = inject(BonusResourceService);
    rtmsConfig = inject(RtmsLayerConfig);
    page = inject(Page);
    private cashierService = inject(CashierService);

    public bonusHeader: string = '';
    private bonusTeaserRedirectUrl: string;

    override ngOnInit(): void {
        super.ngOnInit();
        if (this.message.content.bonusHeader) {
            this.bonusHeader = this.message.content.bonusHeader.replace(/<[^>]*>/g, '');
        }
        this.bonusTeaserRedirectUrl = this.rtmsConfig.bonusTeaserRedirectUrl.replace('{culture}', this.page.lang);
    }

    decline() {
        // drop bonus
        this.bonusResourceService.dropBonusOffer({ bonusId: this.message.bonusId, agentName: 'System', reason: 'PLP' }).subscribe(() => this.close());
    }

    accept() {
        // is bonus tnc is accepted and it is deposit bonus, redirect to cashier
        if (this.message.isBonusTncAccepted) {
            this.postTncAcceptanceAction();
        } else {
            // try to accept bonus tnc
            this.bonusResourceService
                .updateBonusTncAcceptance({
                    offerId: +this.message.offerId,
                    offerArc: 1,
                    isCampaignBonus: this.message.isCampaignBonus,
                    tncAcceptanceFlag: true,
                })
                .subscribe((update: boolean) => {
                    if (update) {
                        this.postTncAcceptanceAction();
                    } else {
                        this.close();
                    }
                });
        }
    }

    private postTncAcceptanceAction() {
        this.close();
        if (this.message.isNoDepositBonus) {
            // if it is no deposit bonus redirect to bonus page
            this.redirectTo(this.bonusTeaserRedirectUrl);
        } else {
            // if it is deposit bonus redirect to cashier
            this.goToCashier(this.message.bonusCode);
        }
    }

    private goToCashier(bonusCode: any) {
        this.cashierService.goToCashierDeposit({
            returnUrl: this.bonusTeaserRedirectUrl,
            skipQuickDeposit: true,
            queryParameters: { ['bonusCodeForPrefill']: bonusCode },
        });
    }
}
